import { useParams, useLocation } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import TemplateDefault from '../../layout/TemplateDefault';
import { FullHeightOnly } from '../../components/shared/Grid';
import MyFilesV2ViewModel from '../MyFilesV2/viewModel';
import FileListPage from '../MyFilesV2/FileListPage';
import AttendanceDeclarationPage from '../MyFilesV2/AttendanceDeclarationPage';
import { Files } from '../../services/journey.service';

export function FileCategoryPageContent() {
  const { category } = useParams<{ category: string }>();
  const location = useLocation();
  const stateFiles = (location.state as { files?: Files } | null)?.files ?? null;

  const { isLoading, files: fetchedFiles } = MyFilesV2ViewModel();

  const files = fetchedFiles ?? stateFiles;
  const loading = !stateFiles && isLoading;

  if (category === 'declaracao-de-comparecimento') {
    return <AttendanceDeclarationPage />;
  }

  return loading ? (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress sx={{ color: 'brand.darkGreen' }} />
    </Box>
  ) : (
    <FileListPage files={files} category={category ?? ''} />
  );
}

export default function FileCategoryPage() {
  return (
    <TemplateDefault>
      <FullHeightOnly>
        <Grid container>
          <Grid item xs={0} sm={1} md={3} />
          <Grid item xs={12} sm={10} md={6}>
            <FileCategoryPageContent />
          </Grid>
          <Grid item xs={0} sm={1} md={3} />
        </Grid>
      </FullHeightOnly>
    </TemplateDefault>
  );
}
